import { useState } from 'react';
import { motion } from 'framer-motion';
import { api } from '../api';

type Props = {
  memberName: string;
  initial?: { perfect?: string; wrong?: string; timeSink?: string; ask?: string };
  onSubmitted: () => void;
};

export function SubmitForm({ memberName, initial, onSubmitted }: Props) {
  const [perfect, setPerfect]   = useState(initial?.perfect ?? '');
  const [wrong,   setWrong]     = useState(initial?.wrong ?? '');
  const [timeSink, setTimeSink] = useState(initial?.timeSink ?? '');
  const [ask,     setAsk]       = useState(initial?.ask ?? '');
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState('');

  const submit = async () => {
    setBusy(true);
    setMsg('');
    try {
      await api.responses.submit({ memberName, perfect, wrong, timeSink, ask });
      setMsg('Sent to Erick ✓  Your answers stay private.');
      onSubmitted();
    } catch {
      setMsg('Save failed. Try again.');
    } finally {
      setBusy(false);
    }
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      className="card"
    >
      <div className="mb-4">
        <div className="text-[11px] uppercase tracking-widest text-coast-muted">
          {memberName} · Weekly Check-In
        </div>
        <h2 className="font-heading text-3xl leading-tight">This Week</h2>
      </div>

      <div className="space-y-4">
        <Field
          number="1"
          label="What went PERFECT?"
          accent="border-l-4 border-semantic-green"
          value={perfect} onChange={setPerfect}
          placeholder="Wins, breakthroughs, moments that clicked."
        />
        <Field
          number="2"
          label="What went WRONG?"
          accent="border-l-4 border-semantic-red"
          value={wrong} onChange={setWrong}
          placeholder="Broken systems, dropped balls, friction."
        />
        <Field
          number="3"
          label="Where did MOST TIME go?"
          accent="border-l-4 border-semantic-amber"
          value={timeSink} onChange={setTimeSink}
          placeholder="Time sinks — worth it or not."
        />
        <Field
          number="4"
          label="What can ERICK help with?"
          accent="border-l-4 border-coast-blue"
          value={ask} onChange={setAsk}
          placeholder="Direct asks. Be specific."
        />
      </div>

      <div className="mt-5">
        <button
          className="btn btn-primary btn-block"
          onClick={submit}
          disabled={busy}
          style={{ minHeight: 56 }}
        >
          {busy ? 'Saving…' : (initial ? 'Update My Retro' : 'Submit My Retro')}
        </button>
        <div className={`text-xs mt-2 ${msg.startsWith('Submitted') ? 'text-coast-blue' : 'text-coast-muted'}`}>
          {msg || 'You can update your answers anytime this week.'}
        </div>
      </div>
    </motion.div>
  );
}

function Field({
  number, label, value, onChange, accent, placeholder,
}: {
  number: string; label: string; value: string; onChange: (v: string) => void;
  accent: string; placeholder: string;
}) {
  return (
    <div className={`pl-3 ${accent}`}>
      <label className="block text-xs uppercase tracking-widest text-coast-muted mb-1">
        <span className="text-coast-blue mr-1">{number}.</span> {label}
      </label>
      <textarea
        className="textarea"
        placeholder={placeholder}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        rows={3}
      />
    </div>
  );
}
